import React from 'react';

const UserItemDelete = ({ row, onClick }) => {
  if (row?.expireAt === '-') {
    return <div></div>;
  }

  return (
    <div>
      <button className={"error"} style={{height : 20, fontSize : 10}} onClick={onClick}>
        삭제
      </button>
    </div>
  );
};

export default UserItemDelete;
